import { render, staticRenderFns } from "./mount.vue?vue&type=template&id=12ab181c&scoped=true&"
import script from "./mount.vue?vue&type=script&lang=js&"
export * from "./mount.vue?vue&type=script&lang=js&"
import style0 from "./mount.vue?vue&type=style&index=0&id=12ab181c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab181c",
  null
  
)

export default component.exports